import {StoreAction} from "web-vcore";
import {store} from "../../index.js";

export class CopiedData {
	static none() { return new CopiedData(); }

	constructor(data?: Partial<CopiedData>) { Object.assign(this, data); }
	journalPath: {entryId: string, segmentId: string, sceneIndex?: number|n} |n;
	mapObjects: {
		ids: string[],
		mode: "cut" | "copy",
	}|n;
}
export function JournalPathToString(journalPath: NonNullable<CopiedData["journalPath"]>) {
	return `${journalPath.entryId}/${journalPath.segmentId}${journalPath.sceneIndex != null ? `/${journalPath.sceneIndex}` : ""}`;
}

// the broadcast-channel allows us to easily replicate the node-copy operation in other tabs, enabling easy copy-paste between tabs
var ACTSetCopiedData_broadcastChannel = g.BroadcastChannel != null ? new BroadcastChannel("ACTSetCopiedData_broadcastChannel") : null;
if (ACTSetCopiedData_broadcastChannel) {
	ACTSetCopiedData_broadcastChannel.onmessage = (ev: MessageEvent)=>{
		const {copiedData} = ev.data as {copiedData: CopiedData};
		ACTSetCopiedData(copiedData, false);
	};
}
export const ACTSetCopiedData = StoreAction((copiedData: CopiedData, broadcastToOtherTabs = true)=>{
	store.main.copiedData = copiedData;
	if (broadcastToOtherTabs && ACTSetCopiedData_broadcastChannel) {
		ACTSetCopiedData_broadcastChannel.postMessage({copiedData});
	}
});